/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
import _ from 'lodash';

/* eslint-disable no-param-reassign */
export default class SelectWorkspaceService {
    constructor() {
        /* 组件宽度 */
        this.treeWidth = '660px';

        /* border圆角 */
        this.borderRadius = '0px 0px 4px 4px';

        /* 允许工作空间类型抽屉折叠 */
        this.allowCollapse = false;

        /* 是否多选(显示多选框) */
        this.multipleFolder = true;

        /* 默认展开全部节点 */
        this.defaultExpandAll = false;

        /* 严格检查，启用则父子不联动 */
        this.checkStrictly = true;

        /* 是否显示专利数量 */
        this.isShowPatentCount = true;

        /* 搜索关键词，用来匹配高亮 */
        this.keyword = '';

        /* 默认选中的folder id list */
        this.defaultFolderIdList = [];

        /* 最多文件夹数量 */
        this.maxFoldersCount = undefined;

        /* 最多专利数量 */
        this.maxPatentsCount = undefined;

        /* 自管理数据 */
        this.workspacesData = {
            self: [],
            shared: [],
            public: [],
        };
        this.folderList = [];
        this.allFolderList = [];

        /* 选中的folderList */
        this.selectedFolderList = [];
    }

    /**
     * 返回 workspace list
     * @returns
     */
    async getWorkspaces(/* keyword */) {
        return Promise.resolve(this.workspacesData);
    }

    async getWorkspacesData() {
        this.workspacesData = await this.getWorkspaces(_.trim(this.keyword));
        return this.workspacesData;
    }

    get myWorkspaces() {
        return this.workspacesData.self || [];
    }

    get sharedWorkspaces() {
        return this.workspacesData.shared || [];
    }

    get publicWorkspaces() {
        return this.workspacesData.public || [];
    }

    setLoadWorkspacesKeyword(keyword) {
        this.keyword = keyword;
    }

    /* 返回folder list */
    async getFolders() {
        return Promise.resolve(this.folderList);
    }

    async getFoldersData(space) {
        const spaceId = _.get(space, 'space_id');

        const spaceName = _.get(space, 'space_name');
        const folderList = await this.getFolders(spaceId, this.keyword);
        this.folderList = _.map(folderList, (folder) => ({
            ...folder,
            space_id: spaceId,
            space_name: spaceName,
        }));
        this.allFolderList = _.concat(this.allFolderList, this.folderList);
        return this.folderList;
    }

    /**
     * 返回 树结构的foldlist
     *
     * @returns
     */
    folderListToTree(folderList) {
        const tree = {};
        let rootFolders = folderList.map((item) => {
            const folderItem = item;
            folderItem.id = item.folder_id;
            if (item.parent_id !== '-root') {
                if (!tree[item.parent_id]) {
                    tree[item.parent_id] = { child: [] };
                }
                tree[item.parent_id].child.push(item);
                return undefined;
            }
            return item;
        });
        rootFolders = rootFolders.filter((d) => d);
        const folderTree = this.mapChild(rootFolders, tree);
        return folderTree;
    }

    mapChild(handlerList = [], unHandlerList) {
        handlerList.map((item) => {
            if (unHandlerList[item.folder_id]) {
                item.children = _.cloneDeep(unHandlerList[item.folder_id].child);
                delete unHandlerList[item.folder_id];
                if (!_.isEmpty(unHandlerList)) {
                    this.mapChild(item.children, unHandlerList);
                }
            }
            return item;
        });
        return handlerList;
    }

    getParentFolderNameList(parentId) {
        let list = [];
        const parent = _.find(this.allFolderList, { folder_id: parentId });

        if (parent) {
            const parentName = _.get(parent, 'folder_name');
            list.push(parentName);

            const grandParentId = _.get(parent, 'parent_id');

            if (grandParentId) {
                list = _.concat(this.getParentFolderNameList(grandParentId), list);
            }
        }
        return list;
    }

    // 选中文件夹之后的回调

    folderChangeCallback(folderList) {
        console.log(folderList);
    }

    // 文件夹选中事件
    onSelectedFolderChange(list) {
        this.setSelectedFolderList(list);
        this.folderChangeCallback(this.selectedFolderList);
    }

    setSelectedFolderList(list) {
        this.selectedFolderList = list;
    }

    setDefaultFolderIdList(list) {
        this.defaultFolderIdList = list;
    }

    overLimitCallback() {
        console.log('overlimit');
    }

    get selectedFolderListWithParentName() {
        return this.selectedFolderList.map((folder) => ({
            ...folder,
            parent_name_list: this.getParentFolderNameList(folder.parent_id),
        }));
    }
}
